import { faChevronLeft, faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import classNames from "classnames";
import { isWebView } from "../../utils";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import Store from "../../utils/Store";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import { get } from "lodash";
import { useEffect } from "react";

interface SettingHeaderProps {
  onBack?: () => void;
  onClose?: () => void;
  pageTitle: string;
  pageNo?: number;
  setPageNo?: (pageNo: number) => void;
  sideMenu?: React.ReactNode;
}

const SettingHeader = (props: SettingHeaderProps) => {
  const { onBack, onClose, pageTitle, pageNo, setPageNo, sideMenu } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  const pageNoParam = Number(get(router, ["query", "params", "1"], ""));

  useEffect(() => {
    if (setPageNo && isMobile) {
      setPageNo(pageNoParam || 0);
    }
  }, [pageNoParam]);

  const onBackClick = () => {
    if (onBack) {
      onBack();
    } else if (isMobile) {
      router.back();
    } else if (setPageNo && pageNo) {
      setPageNo(pageNo - 1);
    }
  };

  const onCloseClick = () => {
    Store.update((s) => {
      s.isSettingsOpen = false;
    });
    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      className={classNames(
        "flex items-center border-b border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-200 w-full",
        {
          "pt-7": isWebView(),
        }
      )}
    >
      <div
        className={classNames("w-9 h-8 flex items-center justify-center", {
          "sm:w-6": !(isMobile || pageNo),
        })}
      >
        <button
          className={classNames(
            "text-gray-800 dark:text-gray-200 flex items-center justify-center h-full w-full",
            {
              hidden: !(isMobile || pageNo),
            }
          )}
          onClick={onBackClick}
        >
          <AwesomeIcon name={faChevronLeft} className="p-4 text-base" />
        </button>
      </div>
      <div className="sm:py-4 text-xl sm:text-lg w-full flex items-center justify-between text-center sm:text-left">
        <p>{t(`settings.${pageTitle}`)}</p>
        {sideMenu && sideMenu}
      </div>
      <div className="w-9 h-8 flex items-center justify-center">
        <button
          onClick={onCloseClick}
          className="sm:flex hidden items-center justify-center h-full w-full"
        >
          <AwesomeIcon name={faXmark} className="p-4 text-base" />
        </button>
      </div>
    </div>
  );
};

export default SettingHeader;
